import { BROWSER } from "@workwave-tidal/env";
import { Watermark } from "./Watermark.js";
const sym = Symbol.for("\u2026");
function checkLicense() {
  const obj = window[sym];
  return obj?.isValid ?? false;
}
function delayWatermark() {
  setTimeout(() => {
    const isValid = checkLicense();
    if (!isValid && Watermark.instancesCount === 0) {
      new Watermark();
    }
  }, 3 * 1e3);
}
function validateTidalLicense() {
  if (BROWSER) {
    try {
      if (typeof globalThis.window === "undefined") return;
      if (window.document && window.document.readyState !== "loading") {
        delayWatermark();
      }
      window.addEventListener("DOMContentLoaded", () => {
        delayWatermark();
      });
    } catch (_e) {
      console.error(`[Tidal] Error validating the license!`);
    }
  }
}
export {
  validateTidalLicense
};
//# sourceMappingURL=validateTidalLicense.js.map
